import React, { useEffect, useRef, useState, useCallback, memo } from 'react';

import CommonImage from '@/components/CommonImage';
import InputField from '@/components/InputField';
import useDebounce from '@/hooks/useDebounce';
import Chip from '@/features/filter/Chip';

const MyProjectTopbar = memo(({ projectCount = 0, onOpenCreateProjectModal, onFilterToggle, onSearch }) => {
	const [isShowSearch, setIsShowSearch] = useState(true);
	const [searchValue, setSearchValue] = useState('');
	const debouncedSearchValue = useDebounce(searchValue, 500);
	const searchRef = useRef(null);

	const handleSearch = useCallback((e) => {
		setSearchValue(e.target.value);
	}, []);

	const toggleSearch = useCallback(() => {
		setIsShowSearch((prev) => !prev);
	}, []);

	const handleOpenCreateModal = useCallback(() => {
		onOpenCreateProjectModal((prev) => !prev);
	}, [onOpenCreateProjectModal]);

	useEffect(() => {
		if (onSearch) {
			onSearch(debouncedSearchValue);
		}
	}, [debouncedSearchValue, onSearch]);

	useEffect(() => {
		if (isShowSearch && searchRef.current) {
			searchRef.current.focus();
		}
	}, [isShowSearch]);

	const projectLabel = projectCount > 1 ? 'Projects' : 'Project';

	return (
		<div className="top-header bg-white">
			<div className="page-title-area d-flex align-items-center justify-content-between">
				<div className="top-header-left">
					<div onClick={onFilterToggle} className="cursor-pointer d-flex align-items-center gap-2">
						<CommonImage src="/icons/filter24.svg" />
						<p className="medium-14 gray_dark_02 weight-500">
							{projectCount} {projectLabel}
						</p>
					</div>

					<div className="chip-container mt-3 mb-3">
						<div className="chips">
							<Chip maxChar={80} />
						</div>
					</div>
				</div>

				<div className="top-header-right">
					<div className="filter-actions compare-filter-actions">
						<div className="form-group size32 m-0 mr-1 search-filter filter-with-animation">
							<div className={`with-icon right-icon ${isShowSearch ? '' : 'hidden'}`}>
								<InputField
									type="text"
									placeholder="Search Project"
									value={searchValue}
									name="search"
									ref={searchRef}
									onChange={handleSearch}
									withWrapper={false}
								/>
								<span className="right-icon" onClick={toggleSearch}>
									<CommonImage src="/icons/search.png" alt="search" />
								</span>
							</div>
						</div>
						<div className="add-new-task">
							<button className="button text size32 px-0" onClick={handleOpenCreateModal}>
								<CommonImage src="/icons/add-round.svg" alt="add" />
								<span className="ml-1 gray_dark_01">Project</span>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
});

export default MyProjectTopbar;
